import React from 'react'
import './adminApp.css';
import Sidebar from './components/Sidebar';

export default function adminShiftManagement() {
    return (
        <>
            <div className="txt-container">
                <Sidebar />
                <div>
                    <h1>Admin Shift Management page</h1>
                </div>
            </div>
        </>
    )
}
